import { getExternalConnectionContacts as _getExternalConnectionContacts } from '@griply/services';
import { ExternalConnectionContact, ID } from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

export const getExternalConnectionContacts = (
  connectionId: ID,
): Promise<ExternalConnectionContact[]> =>
  _getExternalConnectionContacts({
    functions: getFunctions(),
    httpsCallable,
    payload: { connectionId },
  });
